/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {ACTION_BANNER_Z_INDEX} from 'components/banners/ActionBanner';

export const LayoutRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const MenuBox = styled(Box)(() => ({
  width: '100%',
  position: 'relative',
  zIndex: ACTION_BANNER_Z_INDEX + 1,
}));

export const BreadcrumbsContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(3, 4),
  borderBottom: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
}));

export const ContentContainer = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
}));
